module.exports = __webpack_public_path__ + "static/img/icon-overview.d85b1b39.svg";